import React from 'react';
import { MetricInfo } from './MetricInfo';
import { getTotalOperatingSeconds, getUtilizationByTime } from '../../utils/utilizationTime';

const formatNumber = (value, digits) => Number(value || 0).toLocaleString(undefined, { maximumFractionDigits: digits });
const formatHours = (seconds) => `${formatNumber(seconds / 3600, 1)} h`;

export function UtilizationByMachineInfo({ id, running, total }) {
    const value = total > 0 ? (running / total) * 100 : 0;
    return (
        <MetricInfo id={id} label="Utilization by Machine">
            <p className="mb-1"><strong>Running machines ÷ Total machines × 100</strong></p>
            <p className="mb-2">= {running} ÷ {total} × 100 = <strong>{value.toFixed(1)}%</strong></p>
            <ul>
                <li><strong>Running machines</strong>: machines with output on the selected day whose last submission is not older than their data interval + 15 minutes.</li>
                <li><strong>Total machines</strong>: active machines in this category for today. Past days retain historical machines.</li>
            </ul>
        </MetricInfo>
    );
}

export function UtilizationByTimeInfo({ id, machines, availableHours }) {
    const count = (machines || []).length;
    const operatingSeconds = getTotalOperatingSeconds(machines);
    const value = getUtilizationByTime(machines, availableHours);
    return (
        <MetricInfo id={id} label="Utilization by Time">
            <p className="mb-1"><strong>Operating time ÷ (Machines × Scheduled available time) × 100</strong></p>
            {availableHours ? (
                <p className="mb-2">
                    = {formatHours(operatingSeconds)} ÷ ({count} × {formatNumber(availableHours, 2)} h) × 100 = <strong>{value.toFixed(1)}%</strong>
                </p>
            ) : (
                <p className="mb-2">Loading the scheduled available time…</p>
            )}
            <ul>
                <li><strong>Operating time</strong>: planned production time − unplanned stop time, the same as the daily OEE. It is 0 until a machine's first valid submission of the day.</li>
                <li><strong>Machines</strong>: active machines in this category for today. Past days retain historical machines.</li>
                <li><strong>Scheduled available time</strong>: hours per machine per day, set in Settings &gt; Targets and Utilities.</li>
            </ul>
        </MetricInfo>
    );
}
